module.exports = __webpack_public_path__ + "img/Slots.6f5a2919.jpg";